export enum AAccentLineSize {
  OnePx = '1px',
  ThreePx = '3px',
  FivePx = '5px',
}

export enum AAccentLineAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export interface AAccentLineProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: AAccentLineSize;
  alignment?: AAccentLineAlignment;
}
